<template>
    <b-card class="mb-5">
        <b-row>
          <b-col>
            <h3>{{$route.name}}</h3>
            <b-breadcrumb>
                <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
            </b-breadcrumb>
          </b-col>
          <b-col>
            <div class="mt-3 mb-3 float-right">
              <b-button v-b-tooltip.hover.top variant="primary" title="Add" :to="'/settings/user/create'"><font-awesome-icon icon="plus"/></b-button>
            </div>
          </b-col>
        </b-row>
        <div class="border-bottom"></div>
        <b-row>
            <b-col md="12">
                <b-row class="mt-3 mb-3">
                    <b-col md="3">
                      <b-form-input v-model="tableFilter.search" v-on:afterHit="doFilter" placeholder="Search User By Name" customQueryParamName="search" />
                    </b-col>
                    <b-col md="3">
                      <b-form-select v-model="tableFilter.branch" :options="branchList" />
                    </b-col>
                    <b-col md="3">
                      <b-form-select v-model="tableFilter.modelRole" :options="roleList" />
                    </b-col>
                    <b-col md="3">
                      <b-form-select v-model="tableFilter.department" :options="departmentList" />
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <paginated-table ref="dataTable" :can-delete="false" :can-edit="true" :can-approve="false" :can-reject="false" :data-url="apiUrl.profile" :data-key="dataKey" :data-columns="columns" :data-params="['search', 'branch_uuid', 'role', 'department_uuid']">
        </paginated-table>
    </b-card>
</template>
<script>
    import PaginatedTable from '@/components/PaginatedTable'
    export default {
        name: 'report-index',
        components: {
            PaginatedTable
        },
        data () {
            return {
                dataKey: 'profile',
                apiUrl: {
                    profile : window.AppConfig.apiUrl + 'profile',
                    branch : window.AppConfig.apiUrl + 'branch',
                    department : window.AppConfig.apiUrl + 'department'
                },
                departmentList: [
                  {
                    value: null,
                    text: 'All Department'
                  }
                ],
                columns: [
                    {
                        key: 'fullName',
                        label: 'Name',
                        sortable: true
                    },
                    {
                        key: 'username',
                        label: 'Username',
                        sortable: true
                    },
                    {
                        key: 'branch',
                        label: 'Branch',
                        sortable: true
                    },
                    {
                        key: 'departmentUser',
                        label: 'Department',
                        sortable: true
                    },
                    {
                        key: 'phone',
                        label: 'Phone',
                        sortable: true
                    },
                    {
                        key: 'role',
                        label: 'Role',
                        sortable: true
                    },
                    {
                        key: 'leaveQuota',
                        label: 'Leave Quota',
                        sortable: true
                    },
                    {
                        key: 'actions',
                        label: ''
                    }
                ],
                tableFilter: {
                    branch: null,
                    branch_uuid: this.$route.query.branch_uuid,
                    department: null,
                    department_uuid: this.$route.query.department_uuid,
                    modelRole: null,
                    role: this.$route.query.role
                },
                branchList: [
                  {
                    value: null,
                    text: 'All Branch'
                  }
                ],
                roleList: [
                  {
                    value: null,
                    text: 'All Role'
                  },
                  {
                    value: 'Admin',
                    text: 'Admin'
                  },
                  {
                    value: 'User',
                    text: 'User'
                  },
                  {
                    value: 'Supervisor',
                    text: 'Supervisor'
                  },
                  {
                    value: 'Helpdesk',
                    text: 'Helpdesk'
                  },
                  {
                    value: 'Manager',
                    text: 'Manager'
                  }
                ]
            }
        },
        watch: {
          'tableFilter.search' () {
              this.doFilter()
            },
          'tableFilter.branch' () {
              this.doFilter()
          },
          'tableFilter.modelRole' () {
              this.doFilter()
          },
          'tableFilter.department' () {
              this.doFilter()
          }
        },
        mounted () {
          this.getBranch()
          this.getDepartment()
        },
        methods: {
            doFilter () {
              this.tableFilter.branch_uuid = this.tableFilter.branch
              this.tableFilter.department_uuid = this.tableFilter.department
              this.tableFilter.role = this.tableFilter.modelRole
              this.$refs.dataTable.doFilter(this.tableFilter)
            },
            getDepartment () {
              this.$http.get(this.apiUrl.department + '?limit=100').then(resp => {
                resp.data._embedded.department.forEach(data => {
                  this.departmentList.push({
                    value: data.uuid,
                    text: data.name
                  })
                })
              })
            },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD HH:mm')
                } else {
                    return '-'
                }
            },
            reset () {
                this.tableFilter.requestedBy = null
            },
            getBranch () {
              this.$http.get(this.apiUrl.branch + '?limit=100').then(resp => {
                resp.data._embedded.branch.forEach(data => {
                  this.branchList.push({
                    value: data.uuid,
                    text: data.name
                  })
                })
              })
            }
        }
    }
</script>